(() => {
  const initialize = (container) => {
    if (container.dataset.collectionRevealReady === 'true') return;

    const button = container.querySelector('button[aria-controls]');
    const grid = button && document.getElementById(button.getAttribute('aria-controls'));
    if (!button || !grid) return;

    const items = Array.from(grid.querySelectorAll('[data-collection-reveal-item]'));
    if (!items.length) return;

    container.dataset.collectionRevealReady = 'true';
    button.addEventListener('click', () => {
      items.forEach((item) => {
        item.hidden = false;
      });
      button.setAttribute('aria-expanded', 'true');
      button.hidden = true;
      container.hidden = true;
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-collection-reveal]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
